let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aV58s")).then(() => parcelRequire('aSAfy'));